export const richDetailsAttr = 'data-rd';
export const richDetailsSingletonAttr = 'data-rd-sngl';
export const richDetailsDesktopTriggersOnHoverAttr = 'data-rd-dsktp-hvr';
export const richDetailsCloseFromWithinAttr = 'data-rd-clse-wthn';

type Args = {
  singleton?: boolean;
  desktopTriggersOnHover?: boolean;
};

export function richDetailsAttributes({
  singleton,
  desktopTriggersOnHover,
}: Args) {
  return {
    [richDetailsAttr]: '',
    [richDetailsSingletonAttr]: singleton ? '' : undefined,
    [richDetailsDesktopTriggersOnHoverAttr]: desktopTriggersOnHover
      ? ''
      : undefined,
  };
}
